import { z } from 'zod';

/**
 * e-Fatura / e-Arsiv (Parasut entegrasyonu).
 *
 * Tasarim kaynagi: Claude Design - "otelcms Fatura.dc.html".
 * API sozlesmesi: https://apidocs.parasut.com (OpenAPI 2.0).
 */

export const FATURA_TIPLERI = ['E_FATURA', 'E_ARSIV', 'MATBU'] as const;
export const faturaTipiSchema = z.enum(FATURA_TIPLERI);
export type FaturaTipi = z.infer<typeof faturaTipiSchema>;

export const FATURA_DURUMLARI = ['TASLAK', 'GONDERILDI', 'ONAYLANDI', 'HATA', 'IPTAL'] as const;
export const faturaDurumSchema = z.enum(FATURA_DURUMLARI);
export type FaturaDurum = z.infer<typeof faturaDurumSchema>;

/** Tasarimdaki dort adimli akis serisi. */
export const FATURA_ADIMI: Record<FaturaDurum, number> = {
  TASLAK: 1,
  GONDERILDI: 2,
  ONAYLANDI: 3,
  HATA: 2,
  IPTAL: -1,
};

/**
 * Fatura alicisi.
 *
 * SAHIS'ta alici misafirin kendisidir ve bilgisi rezervasyondan okunur;
 * ekrandan alan istenmez. SIRKET'te unvan ve VKN zorunludur - VKN ile GIB
 * mukellefligi sorgulanip e-Fatura mi e-Arsiv mi olacagina karar verilir.
 */
export const faturaAliciSchema = z
  .object({
    folioId: z.string().min(1),
    aliciTip: z.enum(['SAHIS', 'SIRKET']),
    unvan: z.string().trim().min(2).max(200).optional(),
    /** VKN 10 hane; TCKN sahis faturasinda istenmez. */
    vergiNo: z.string().trim().regex(/^\d{10}$/, 'VKN 10 haneli olmalı').optional(),
    vergiDairesi: z.string().trim().max(100).optional(),
    eposta: z.string().email().optional(),
    sehir: z.string().trim().max(60).optional(),
    ilce: z.string().trim().max(60).optional(),
    ulke: z.string().trim().max(60).optional(),
    /** Olusturduktan hemen sonra GIB'e gonder (tasarimdaki varsayilan akis). */
    hemenGonder: z.boolean().optional(),
  })
  .refine((v) => v.aliciTip !== 'SIRKET' || (v.unvan && v.vergiNo), {
    message: 'Şirket faturası için unvan ve VKN gerekli',
    path: ['vergiNo'],
  });
export type FaturaAlici = z.infer<typeof faturaAliciSchema>;

/**
 * Tesisin Parasut ayarlari.
 *
 * `clientId`/`clientSecret`/`refreshToken` yalnizca YAZILIR; hicbir uctan
 * geri donmez, denetim kaydina `***` olarak duser.
 */
export const parasutAyarSchema = z.object({
  parasutAcik: z.boolean().optional(),
  /** Parasut firma numarasi: /v4/<firmaNo>/... yolunun parcasi. */
  parasutFirmaNo: z.string().trim().regex(/^[0-9_]{1,20}$/, 'Firma no rakam olmalı').nullable().optional(),
  parasutOtomatikFatura: z.boolean().optional(),
  /** Fatura seri oneki: "ALA" -> ALA2026000117 */
  faturaSeri: z.string().trim().max(8).nullable().optional(),
  clientId: z.string().trim().max(200).optional(),
  clientSecret: z.string().trim().max(200).optional(),
  refreshToken: z.string().trim().max(500).optional(),
});
export type ParasutAyar = z.infer<typeof parasutAyarSchema>;
